/**
 * CalendarPageV2.tsx — BarberPro (g=false)
 */

import React from 'react';
import { CalendarModuleV2 } from '../components/calendar/CalendarModuleV2';
import '../components/calendar/calendar-v2.css';

export default function CalendarPageV2() {
  return (
    <div
      className="cal-v2-root"
      data-app="barber"
      style={{
        position: 'absolute',
        inset: 0,
        zIndex: 10,
      }}
    >
      <CalendarModuleV2 g={false} />
    </div>
  );
}
